'use strict';exports.__esModule = true;exports.loadCitiesForLinks = exports.loadCities = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _uniqBy = require('lodash/uniqBy');var _uniqBy2 = _interopRequireDefault(_uniqBy);
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var loadCities = (0, _reduxAct.createAction)('/LOAD_CITIES');
var loadCitiesSuccess = (0, _reduxAct.createAction)('/LOAD_CITIES_SUCCESS');
var loadCitiesFail = (0, _reduxAct.createAction)('/LOAD_CITIES_FAIL');

var loadCitiesForLinks = (0, _reduxAct.createAction)('/LOAD_CITIES_FOR_LINKS');
var loadCitiesForLinksSuccess = (0, _reduxAct.createAction)('/LOAD_CITIES_FOR_LINKS_SUCCESS');
var loadCitiesForLinksFail = (0, _reduxAct.createAction)('/LOAD_CITIES_FOR_LINKS_FAIL');

var fetchLoad = function fetchLoad(_ref) {var params = _ref.params,limit = _ref.limit;return _axios2.default.get('/cities?$sort=-priority' + (limit ? '&$limit=' + limit : ''), { params: params }).
  then(loadCitiesSuccess, loadCitiesFail);};

var fetchLoadLinks = function fetchLoadLinks(_ref2) {var params = _ref2.params;return _axios2.default.get('/cities?$sort=-priority', { params: params }).
  then(loadCitiesForLinksSuccess, loadCitiesForLinksFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadLinks = function handleLoadLinks(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    linksLoading: true }),
  promise(fetchLoadLinks, action));};

var handleLoadSuccess = function handleLoadSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: action.data.data });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while getting cities');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    error: error });

};

var handleLoadLinksSuccess = function handleLoadLinksSuccess(state, action) {return Object.assign({},
  state, {
    linksLoading: false,
    linksLoaded: true,
    links: (0, _uniqBy2.default)(action.data.data, 'localisation.en') });};


var handleLoadLinksFail = function handleLoadLinksFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while getting city links');

  return Object.assign({},
  state, {
    linksLoading: false,
    linksLoaded: false,
    links: [],
    linksError: error });

};

var initialState = {
  loaded: false };


var cities = (0, _reduxAct.createReducer)(function (on) {
  on(loadCities, handleLoad);
  on(loadCitiesSuccess, handleLoadSuccess);
  on(loadCitiesFail, handleLoadFail);
  on(loadCitiesForLinks, handleLoadLinks);
  on(loadCitiesForLinksSuccess, handleLoadLinksSuccess);
  on(loadCitiesForLinksFail, handleLoadLinksFail);
}, initialState);exports.


loadCities = loadCities;exports.
loadCitiesForLinks = loadCitiesForLinks;exports.default =


cities;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/cities.js
// module id = 3050
// module chunks = 0